import { render } from "./ProjectPage.vue?vue&type=template&id=a8ce2034&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=a8ce2034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ce2034"]])

export default __exports__